/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserVerificationRequirement {
  NotAllowed = 'not_allowed',
  Allowed = 'allowed',
  Required = 'required'
}
